"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-hover-observer/dist/utils/noop.js
 ** module id = 1092
 ** module chunks = 0
 **/